import BlogEditContainer from "../../../../Component/Application/blogs/EditBlog/BlogEdit";

const EditBlog = () => {
  return (
    <div className="page-body">
      <BlogEditContainer />
    </div>
  );
};

export default EditBlog;
